// extracted by mini-css-extract-plugin
export var label = "_fo-0";
export var treatmentCard = "_fo-1";